export enum AMPLITUDE_FEATURE_FLAG_KEYS {
  ENABLE_PAYSLIP_VALIDATION = 'enable-payslip-validation',
  ENABLE_UK_LENDER_REVEAL_CLIENT = 'enable-uk-lender-reveal-client',
  ENABLE_TESLA_GFV_EXPERIENCE = 'enable-tesla-gfv-experience',
  ENABLE_MOBILE_REASSURANCE = 'enable-mobile-reassurance',

  // Don't prefix new flags with "enable-", renaming existing ones is tech debt.
  UK_ADDRESS_SEARCH = 'uk-address-search',
  DASH_MAINTENANCE_MODE = 'dash-maintenance-mode',
  BANK_STATEMENTS_OUTAGE_MODE = 'bank-statements-outage-mode',
  VEHICLE_CHECKLIST_V1 = 'vehicle-checklist-v1',
  APP_FLOW_REDESIGN = 'app-flow-redesign',
  DEFAULT_REPAYMENT_FREQUENCY = 'default-repayment-frequency',
  GOOGLE_TAG_GATEWAY = 'google-tag-gateway',
}
